import {useNavigate} from 'react-router-dom';
import ROUTES from 'constants/routes';
import VitaButton from 'components/common/VitaButton';
import DivideLine from 'components/common/divideLine';
import {BUTTON_TEXT} from 'constants/index';
import {IMAGES_HOME} from 'constants/info-homepage';
import HeaderText from 'components/common/headerText';
import parse from 'html-react-parser';

const DetailGift = ({data, handleClickExchangeGift}) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="bg-background">
        <HeaderText>
          <div>Chi tiết quà tặng</div>
        </HeaderText>

        {data && (
          <div>
            <div className="max-h-[200px] flex justify-center">
              <img src={data?.coverImage} alt={data?.name || ''} />
            </div>
            <div className="mx-4 mt-1 mb-40">
              <div className="overflow-x-hidden px-2 bg-white rounded-lg shadow-small">
                <div className="py-4 text-xl font-bold text-center uppercase text-primary leading-medium">
                  {data?.name || ''}
                </div>

                <DivideLine />
                <div className="grid grid-cols-3 py-4">
                  <div className="flex flex-col items-center">
                    <div className="text-lg font-normal tracking-tighter leading-medium">Số xu</div>
                    <div className="flex items-center text-xl font-semibold leading-medium">
                      <span>{data?.point || data?.point === 0 ? data?.point : ''}</span>
                      <span>
                        <img src={IMAGES_HOME?.SVGCoin} alt="coin" />
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-col items-center">
                    <div className="text-lg font-normal tracking-tighter leading-medium">
                      Giá trị
                    </div>
                    <div className="text-xl font-semibold leading-medium">
                      {data?.money?.toLocaleString() || ''}đ
                    </div>
                  </div>
                  <div className="flex flex-col items-center">
                    <div className="text-lg font-normal tracking-tighter leading-medium">
                      Còn hàng
                    </div>
                    <div className="text-xl font-semibold leading-medium">
                      {data?.total || data?.total === 0 ? data?.total : ''}
                    </div>
                  </div>
                </div>
                <DivideLine />
                <div className="py-4 text-lg font-normal tracking-tighter text-black leading-medium">
                  {/* {data?.description || ''} */}
                  {data?.description ? parse(data?.description) : ''}
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="fixed bottom-0 px-6 pt-2 pb-4 w-full bg-background">
          <div className="mb-6">
            <VitaButton disabled={!data} onClick={handleClickExchangeGift}>
              {BUTTON_TEXT.GIFT_EXCHANGE}
            </VitaButton>
          </div>
          <div>
            <VitaButton onClick={() => navigate(ROUTES.HOME)} isOutlined>
              {BUTTON_TEXT.ON_HOMEPAGE}
            </VitaButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailGift;
